// src/api/blogApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// Fetch all blogs
export const fetchBlogs = async () => {
  const res = await apiClient.get(`/blogs`, getAuthHeader());
  return res.data?.data || [];
};

// Create blog (with file upload)
export const createBlog = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return await apiClient.post(`/blogs/create`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update blog (PUT request)
export const updateBlog = async (id, payload) => {
    const formData = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (v !== undefined && v !== null) formData.append(k, v);
    });
   
  
    return apiClient.post(`/blogs/update/${id}`, formData, {
      ...getAuthHeader(),
      headers: {
        ...getAuthHeader().headers,
        "Content-Type": "multipart/form-data",
      },
    });
  };

// Delete blog
export const deleteBlog = async (id) => {
  return await apiClient.delete(`/blogs/${id}`, getAuthHeader());
};
